import React, { useState } from "react";
import "./BookingsTable.css";
import { useNavigate } from "react-router-dom";
import { useChatData } from "../../../Context/chatDataContext";
import EditBookingModal from "../EditBookingModal/EditBookingModal";
import { FiEdit, FiEye } from "react-icons/fi";
import { editBookingAPI } from "../../../utils/APIs/bookingsApis";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";
import AssignPhotographerModal from "./AssignPhotographerModal/AssignPhotographerModal";
import FloatBookingModal from "./FloatBookingModal/FloatBookingModal";
import CustomizeHourlyFloatModal from "./CustomizeHourlyFloatModal/CustomizeHourlyFloatModal";
import { isCustomizeHourlyBooking } from "../UpcomingHourlyComponent/UpcomingHourlyBookingTable/HourlyFloatBookingModal/hourlyFloatHelpers";
import EditingFloatBookingModal from "../UpcomingEditingComponent/UpcomingEditingBookingTable/EditingFloatBookingModal/EditingFloatBookingModal";
import ViewDetailsModal from "../../../components/ViewDetailsModal/ViewDetailsModal";
import { buildShootBookingDetailRows } from "../../../utils/viewDetailsBuilders";
import {
  getUserCancelledBookingTitle,
  isUserCancelledBooking,
} from "../../../utils/bookingCancelUtils";

const BookingsTable = ({ data, page, limit, type, refetchData }) => {


  // const dummyData = [
  //   {
  //     shootId: 1,
  //     shoot_id: "BK-1001",
  //     client_id: "CL-01",
  //     client_name: "Rahul Sharma",
  //     shoot_type: "Wedding",
  //     event_date: "2026-02-10",
  //     event_location: "Delhi",
  //     booking_amount: 50000,
  //     payment_mode: "UPI",
  //     payment_type: "Advance",
  //     status: "Confirmed",
  //     payment_status: "Paid",
  //     assigned_photographer: "Amit",
  //     team_studio: "Dream Studio",
  //     notes: "Evening event",
  //   },
  //   {
  //     shootId: 2,
  //     shoot_id: "BK-1002",
  //     client_id: "CL-02",
  //     client_name: "Priya Verma",
  //     shoot_type: "Pre-Wedding",
  //     event_date: "2026-03-05",
  //     event_location: "Jaipur",
  //     booking_amount: 30000,
  //     payment_mode: "Cash",
  //     payment_type: "Full",
  //     status: "Pending",
  //     payment_status: "Unpaid",
  //     assigned_photographer: "Rohit",
  //     team_studio: "Lens Craft",
  //     notes: "",
  //   },
  // ];
  const navigate = useNavigate();
  const { setBooking } = useChatData();

  const handleChatClick = (booking) => {
    setBooking(booking);
    console.log("shootId", booking.bookingId)
    navigate(`/chat/booking/${booking.bookingId}`);
  };
  // const [dummyStateData, setDummyStateData] = useState(dummyData);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [showAssignPhotographerModal, setShowAssignPhotographerModal] = useState(false);
  const [showFloatBookingModal, setShowFloatBookingModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [detailsItem, setDetailsItem] = useState(null);
  const [loading, setLoading] = useState(false)
  const handleEditClick = (booking) => {
    if (isUserCancelledBooking(booking)) return;
    setSelectedBooking(booking);
    setShowEditModal(true);
  };

  const handleGalleryViewClick = (booking) => {
    setSelectedBooking(booking)
    const id = booking?.bookingId || booking?._id || booking?.shootId;
    const photographerId = booking?.photographer_id || "null";
    const clientId = booking?.client_id || "null";
    navigate(`/bookings/view-gallery/${id}/${photographerId}/${clientId}`)
  };



  const handleUpdateBooking = async (updatedData) => {
    console.log("selectedBooking", selectedBooking)
    try {
      setLoading(true)
      const response = await editBookingAPI(selectedBooking.bookingId, updatedData);
      if (response?.data?.success && response?.status === 200) {
        toast.success(response?.data?.message || "Booking and Payment Status Updated successfully!")
        refetchData();
      }
      else {
        toast.error(response?.data?.message || "Failed to Update Booking and Payment Status!")
      }

      // Optional: refresh bookings list
      refetchData();

      setShowEditModal(false);
    } catch (error) {
      setLoading(false)
      console.error("Failed to update booking:", error);
    }
    finally {
      setLoading(false)
    }
  };
  const formatStatus = (value) => {
    if (!value) return "-";

    return value
      .toString()
      .replace(/_/g, " ") // fully_paid → fully paid
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // const handleAssignPhotographer = (booking) => {
  //   setSelectedBooking(booking);
  //   setShowAssignPhotographerModal(true);
  // };
  const handleFloatBooking = (booking) => {
    if (isUserCancelledBooking(booking)) return;
    setSelectedBooking(booking);
    setShowFloatBookingModal(true);
  };

  const isEditingBooking = (booking) => {
    return booking?.serviceCategory === "editing" || 
           booking?.eventType?.toLowerCase().includes("editing") ||
           booking?.service_id?.serviceName?.toLowerCase().includes("editing");
  };

  if (loading) {
    return <Loader />
  }



  return (
    <div className="quote-table-wrapper">


      <table className="quote-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Booking ID</th>
            <th>Client Name</th>
            <th>Event Type</th>
            <th>Event Start Date</th>
            <th>Event End Date</th>
            <th>Event Location</th>
            <th>Booking Amount</th>
            <th>Payment Mode</th>
            {/* <th>Payment Type</th> */}

            <th>Assigned Photographer</th>
            <th>Team / Studio</th>
            <th>Gallery View</th>
            <th>Gallery Upload Status</th>
            <th>Booking Status</th>
            <th>Payment Status</th>
            <th>Details</th>
            <th>Action</th>
            {/* {(type !== "previous") && <th>Action</th>} */}
            {/* {(type !== "previous") && <th>Chat</th>} */}
            <th>Chat</th>

          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="16" className="no-data">
                No bookings found
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr key={item.shootId}>
                {/* Sr */}
                <td className="td-sr">{(page - 1) * limit + index + 1}</td>

                {/* Booking ID */}
                <td>{item.veroaBookingId || "-"}</td>

                {/* Client Name */}
                <td>{item.client_name || "-"}</td>

                {/* Event Type */}
                <td>{item.eventType || "-"}</td>

                {/* Event Date */}
                {/* <td>{item.eventDate || "-"}</td> */}
                <td>{new Date(item.startDate).toLocaleDateString("en-GB")}</td>
                <td>{new Date(item.endDate).toLocaleDateString("en-GB")}</td>


                {/* Event Location */}
                <td>{item.location || "-"}</td>

                {/* Booking Amount */}
                <td>₹ {item.bookingAmount || "-"}</td>

                {/* Payment Mode */}
                <td>{formatStatus(item.paymentMode) || "-"}</td>

                {/* Payment Type */}
                {/* <td>{item.paymentType || "-"}</td> */}


                {/* Assigned Photographer */}
                <td>{item.assigned_photographer || "-"}</td>

                {/* Team / Studio */}
                <td>{item.team_studio || "-"}</td>

                <td>
                  <button
                    className={`upload-btn d-flex align-items-center gap-2 ${!item.assigned_photographer ? "disabled" : ""}`}
                    onClick={() => handleGalleryViewClick(item)}
                    title={!item.assigned_photographer ? "Assign photographer first" : "View Gallery"}
                    disabled={!item.assigned_photographer}
                  >
                    <FiEye size={16} /> View
                  </button>
                </td>
                <td>
                  <span className={`status ${item.galleryStatus}`}>
                    {formatStatus(item.galleryStatus) || "-"}
                  </span>
                </td>

                {/* Booking Status */}
                <td>
                  <span className={`status ${item.displayStatus ? "portal-cancel" : item.status}`}>
                    {item.displayStatus ||
                      ((item.status === "canceled") ? "canceled" : formatStatus(item.status))}
                  </span>
                </td>

                {/* Payment Status */}
                <td>
                  <span className={`status ${item.paymentStatus}`}>
                    {formatStatus(item.paymentStatus) || "-"}
                  </span>
                </td>

                <td>
                  <button
                    type="button"
                    className="view-details-btn"
                    onClick={() => {
                      setDetailsItem(item);
                      setShowDetailsModal(true);
                    }}
                  >
                    View Details
                  </button>
                </td>

                {/* Action */}
                {/* {(type !== "previous") &&  */}
                <td>
                  <div className="d-flex gap-2">
                  <button
                    type="button"
                    className={`upload-btn ${!item.assigned_photographer || isUserCancelledBooking(item) ? "disabled" : ""}`}
                    onClick={() => handleEditClick(item)}
                    title={
                      isUserCancelledBooking(item)
                        ? getUserCancelledBookingTitle(item)
                        : !item.assigned_photographer
                          ? "Assign photographer first"
                          : "Edit Booking"
                    }
                    disabled={!item.assigned_photographer || isUserCancelledBooking(item)}
                  >
                    <FiEdit size={16} />
                  </button>
                    {/* <button
                      className="chat-btn"
                      onClick={() => handleAssignPhotographer(item)}
                      title="Assign Photographer"
                    >
                      Assign Photographer
                    </button> */}

                    <button
                      type="button"
                      className={`upload-btn ${isUserCancelledBooking(item) ? "disabled" : ""}`}
                      onClick={() => handleFloatBooking(item)}
                      disabled={isUserCancelledBooking(item)}
                      title={getUserCancelledBookingTitle(item)}
                    >
                      {item?.assigned_photographer && item?.displayStatus !== "Portal Cancel"
                        ? "View Assigned Photographer"
                        : "Float Booking"}
                    </button>
                  </div>
                </td>

                {/* } */}



                {/* Chat */}
                {/* {(type !== "previous") && <td>
                  <span
                    className="chat-btn"
                    onClick={() => handleChatClick(item)}
                  >
                    💬
                  </span>
                </td>} */}

                <td>
                  <button
                    className="chat-btn chat-circle"
                    onClick={() => handleChatClick(item)}
                    title="Chat"
                  >
                    💬
                  </button>
                </td>



              </tr>
            ))
          )}
        </tbody>

      </table>

      <EditBookingModal
        booking={selectedBooking}
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        onSave={handleUpdateBooking}
        refetchData={refetchData}
      />
      {/* AssignPhotographerModal */}
      <AssignPhotographerModal
        booking={selectedBooking}
        isOpen={showAssignPhotographerModal}
        onClose={() => setShowAssignPhotographerModal(false)}
        // onSave={handleUpdateBooking}
        refetchData={refetchData}
      />

      {showFloatBookingModal &&
        !isEditingBooking(selectedBooking) &&
        isCustomizeHourlyBooking(selectedBooking) && (
        <CustomizeHourlyFloatModal
          booking={selectedBooking}
          isOpen={showFloatBookingModal}
          onClose={() => setShowFloatBookingModal(false)}
          refetchData={refetchData}
        />
      )}

      {showFloatBookingModal &&
        !isEditingBooking(selectedBooking) &&
        !isCustomizeHourlyBooking(selectedBooking) && (
        <FloatBookingModal
          booking={selectedBooking}
          isOpen={showFloatBookingModal}
          onClose={() => setShowFloatBookingModal(false)}
          refetchData={refetchData}
        />
      )}

      {showFloatBookingModal && isEditingBooking(selectedBooking) && (
        <EditingFloatBookingModal
          booking={selectedBooking}
          isOpen={showFloatBookingModal}
          onClose={() => setShowFloatBookingModal(false)}
          refetchData={refetchData}
        />
      )}

      <ViewDetailsModal
        isOpen={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title="Booking Details"
        rows={buildShootBookingDetailRows(detailsItem)}
      />

    </div>
  );
};

export default BookingsTable;
